<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)" color="#004889">
            <v-card flat color="#004889">
                <v-card-text class="pa-0">
                    <ValidationObserver ref="observer1">
                        <v-form ref="warrantyform">
                            <v-list flat color="#004889" class="py-0">
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Customer</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action class="justify-end">
                                        <div class="d-flex align-center f-wrap">
                                            <ValidationProvider v-slot="{ errors }" name="Customer" rules="required">
                                                <v-autocomplete
                                                    v-model="form.customer"
                                                    :items="customers"
                                                    :loading="isLoading"
                                                    :search-input.sync="search"
                                                    hide-no-data
                                                    hide-selected
                                                    item-text="label"
                                                    item-value="value"
                                                    placeholder="Start typing to Search"
                                                    return-object
                                                    required
                                                    :error-messages="errors"
                                                    solo
                                                    flat
                                                    dark
                                                    class="customer-autocomplete"
                                                ></v-autocomplete>
                                            </ValidationProvider>
                                            <v-btn
                                                class="ml-1"
                                                fab
                                                dark
                                                small
                                                text
                                                :to="{ name:'New Customer', params: { redirect: 'New Job' } }"
                                            >
                                                <v-icon dark>
                                                    mdi-plus
                                                </v-icon>
                                            </v-btn>
                                        </div>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Deposit Date</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-menu
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="computedDateFormatted"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                solo
                                                flat
                                                dark
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                            v-model="form.deposit_date"
                                            @input="menu = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Deposit Amount</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Deposit Amount" rules="required">
                                            <v-text-field
                                                v-model="form.deposit_amount"
                                                prefix="$"
                                                required
                                                :error-messages="errors"
                                                solo
                                                flat
                                                dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Deposit Amount Type</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-select
                                            v-model="form.deposit_amount_type"
                                            :items="amountTypes"
                                            item-text="label"
                                            item-value="value"
                                            required
                                            :error-messages="errors"
                                            solo
                                            flat
                                            dark
                                        ></v-select>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row" v-if="form.deposit_amount_type == 'check'">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Check #</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-text-field
                                            v-model="form.check_num"
                                            solo
                                            dark
                                            flat
                                            required
                                        ></v-text-field> 
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-form>
                    </ValidationObserver>
                </v-card-text> 
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn large min-width="98%" color="white accent--text"  @click="submit" :loading="loading" tile>Create</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions> 
            </v-card>
        </v-card>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import axios from 'axios'
    import TokenService from '../../services/storage.service'
    import mixin from '../../mixin/main.js'
    import authmixin from '../../mixin/auth.js'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin, authmixin],
        props: ['id'],
        data () {
            return {
                form: {
                    id: '',
                    deposit_date: new Date().toISOString().substr(0, 10),
                    deposit_amount: '1000',
                    deposit_amount_type: '',
                    check_num: '',
                    customer: {
                        label: '',
                        value: '',
                        object: []
                    },
                },
                search: null,
                isLoading: false,
                loading: false,
                token: '',
                pageTitle: '',
                issues: [],
                jobs: [],
                customers: [],
            }
        },
        created() {
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
        },
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        mounted() {
            if(this.$route.params.customer) {
                this.form.customer.label = this.$route.params.customer.title
                this.form.customer.value = this.$route.params.customer.id
                this.form.customer.object = this.$route.params.customer

                this.customers.push({...this.form.customer})
            }
        },
        computed: {
            ...mapGetters({
                amountTypes: 'data/amountTypes'
            }),
            computedDateFormatted () {
                return this.formatDate(this.form.deposit_date)
            },
        },
        watch: {
            search (val) {
                // Items have already been requested
                if (this.isLoading) return

                this.isLoading = true

                axios.get('crm/customers/search', {
                    params: {
                        keyword: val
                    }
                })
                .then(response => {
                    this.customers = response.data.customers
                    this.$nextTick()
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.isLoading = false))
            },
        },
        methods: {
            async submit() {
                let valid1 = await this.$refs.observer1.validate()

                if(valid1) {
                    this.loading = true
                    axios.post('crm/job/deposit/add', this.form).then(() => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                        this.$router.push({ path: `/deposits` })
                    }).catch(error => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        if(error.response.data.error) {
                            this.$store.commit('SET_SNACK', error.response.data.error)
                        } else {
                            this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                        }
                    })
                } else {
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                }
            },
        }
    }
</script>

<style lang="sass">
.v-chip--select
    &.v-chip
        &.v-chip--clickable
            &.v-size--small
                background: #1976d2

.f-wrap
    width: 100%

    > span 
        min-width: calc(100% - 40px)

.label 
    .v-list-item__title
            white-space: inherit


.repeater
    background: #003a6f
</style>
